import Marionette from "backbone.marionette";
import LogsDetailTpl from "views/logs/logsViewDetail.ejs";

import LogModel from "models/logsModel.js";
var logModel = new LogModel();

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    initialize: function(data) {
        this.id = data.id;
        this.lang = data.lang;
    },
    template: LogsDetailTpl,
    render: function() {
        $("#loaderContainer").show();
        this.model.fetch({
            data: {
                instanceId: S.instanceId,
                order: 'asc',
                column: "fecha_modificado"
            },
            beforeSend: T.useToken,
            success: function(model, response) {
                logModel.set({
                    id: this.model.attributes.itemId
                });
                logModel.fetch({
                    data: {
                        column: 'fecha_modificado',
                        order: 'desc',
                        id: this.model.attributes.itemId,
                        instanceId: S.instanceId,
                    },
                    beforeSend: T.useToken,
                    success: this.applyView.bind(this)
                });
            }.bind(this)
        });

        $("#insertModal").modal('show');
    },
    applyView: function() {
        $("#loaderContainer").hide();
        for (var l in logModel.attributes) {
            if (typeof logModel.attributes[l] === "object" && logModel.attributes[l].source)
                logModel.attributes[l].source = JSON.parse(logModel.attributes[l].source);
        }

        this.$el.html(this.template({
            attributes: this.model.attributes,
            logData: logModel.attributes,
            lang: this.lang
        }));
    },
    events: {
        "click #cancel": "cancel"
    },
    cancel: function() {
        $("#insertModal").modal("hide");
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/logs/logsViewDetail.js
// module id = 192
// module chunks = 0